import {createSlice} from "@reduxjs/toolkit";

const initialCitiesState = {
  listLoading: false,
  actionsLoading: false,
  totalCount: 0,
  entities: null,
  cityForEdit: undefined,
  lastError: null
};
export const callTypes = {
  list: "list",
  action: "action"
};

export const citiesSlice = createSlice({
  name: "cities",
  initialState: initialCitiesState,
  reducers: {
    catchError: (state, action) => {
      state.error = `${action.type}: ${action.payload.error}`;
      if (action.payload.callType === callTypes.list) {
        state.listLoading = false;
      } else {
        state.actionsLoading = false;
      }
    },
    startCall: (state, action) => {
      state.error = null;
      if (action.payload.callType === callTypes.list) {
        state.listLoading = true;
      } else {
        state.actionsLoading = true;
      }
    },
    // getcityById
    cityFetched: (state, action) => {
      state.actionsLoading = false;
      state.cityForEdit = action.payload.cityForEdit;
      state.error = null;
    },
    // findcities
    citiesFetched: (state, action) => {
      const { totalCount, entities } = action.payload;
	  state.listLoading = false;
      state.error = null;
      state.entities = entities;
      state.totalCount = totalCount;
    },
    // createcity
    cityCreated: (state, action) => {
      state.actionsLoading = false;
      state.error = null;
      state.entities.push(action.payload.city);
    },
    // updatecity
    cityUpdated: (state, action) => {
      state.error = null;
      state.actionsLoading = false;
      state.entities = state.entities.map(entity => {
        if (entity.id === action.payload.city.id) {
          return action.payload.city;
        }
        return entity;
      });
    },
    // deletecity
    cityDeleted: (state, action) => {
      state.error = null;
      state.actionsLoading = false;
      state.entities = state.entities.filter(el => el.id !== action.payload.id);
    },
    // deletecities
    citiesDeleted: (state, action) => {
      state.error = null;
      state.actionsLoading = false;
      state.entities = state.entities.filter(
        el => !action.payload.ids.includes(el.id)
      );
    },
    // citiesUpdateState
    citiesStatusUpdated: (state, action) => {
      state.actionsLoading = false;
      state.error = null;
      const { ids, status } = action.payload;
      const normalizedStatus = (status === 0 || status === '0' || status === 'active') ? 'active' : 'inactive';
      state.entities = (state.entities || []).map(entity => {
        if (ids.findIndex(id => id === entity.id) > -1) {
          entity.status = normalizedStatus;
        }
        return entity;
      });
    }
  }
});
